let toastDialog = null
$(document).on("submit", ".newsletter-subscribe", function (e) {
  e.preventDefault()
  removeToast()
  const form = $(this)
  const emailInput = form.find(".email")
  const email = emailInput.val().trim()
  if (!email || !validateEmail(email)) {
    emailInput.addClass("border border-danger shake")
  } else {
    emailInput.removeClass("border border-danger shake")
    moreInfoDialog(email, ({ firstName, lastName, dialog, end }) => {
      const data = {
        type: form.data("type"),
        email,
        firstName,
        lastName,
      }
      const url = algoras.url
        .replace("__CONTROLLER__", "site")
        .replace("__ACTION__", "subscribe-to-newsletter")
      $.ajax({
        type: "post",
        url,
        data,
        dataType: "json",
        beforeSend() {},
        success(response) {
          if (response) {
            toastAlert(true, "thumbs-up", translate("Success subscription!"))
          } else {
            toastAlert(false, "thumbs-down", translate("Already Registered"))
          }
          $(dialog).modal("hide")
          $(dialog).modal("dispose")
          emailInput.val("")
          end()
        },
        error(jqXHR, exception) {
          let msg = ""
          if (jqXHR.status === 0) {
            msg = translate("Not connect, Verify Network.")
          } else if (jqXHR.status == 404) {
            msg = translate("Requested page not found. [404]")
          } else if (jqXHR.status == 500) {
            msg = translate("Internal Server Error [500].")
          } else if (exception === "parsererror") {
            msg = translate("Requested JSON parse failed.")
          } else if (exception === "timeout") {
            msg = translate("Time out error.")
          } else if (exception === "abort") {
            msg = translate("Ajax request aborted.")
          } else {
            msg = translate("Uncaught Error :") + " " + jqXHR.responseText
          }
          toastAlert(false, "thumbs-down", msg)
          end()
        },
      })
    })
  }
})

function translate(message) {
  return algoras.translate[message] || message
}

function moreInfoDialog(email, callback) {
  const template = `
        <div class="modal" tabindex="-1">
            <form class="form modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><bdi>${email}</bdi></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control first-name" placeholder="${translate(
                          "First Name",
                        )}">
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control last-name" placeholder="${translate(
                          "Last Name",
                        )}">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">${translate(
                      "Close",
                    )}</button>
                    <button type="submit" class="btn btn-orange btn-submit">${translate(
                      "Subscribe",
                    )}</button>
                </div>
                </div>
            </form>
        </div>
    `
  const dialog = $(template)
  dialog.find(".modal-dialog").on("submit", function (e) {
    e.preventDefault()
    removeToast()
    const firstNameInput = $(this).find(".first-name")
    const lastNameInput = $(this).find(".last-name")
    const firstName = firstNameInput.val().trim()
    const lastName = lastNameInput.val().trim()
    firstNameInput.removeClass("border border-danger shake")
    lastNameInput.removeClass("border border-danger shake")
    if (!firstName) {
      firstNameInput.addClass("border border-danger shake")
    } else if (!lastName) {
      lastNameInput.addClass("border border-danger shake")
    } else {
      const btn = $(this).find(".btn-submit")
      btn.prop("disabled", true)
      btn.data("text", btn.html())
      btn.html(
        '<div class="spinner-border text-light" role="status" style="width: 1.5rem; height: 1.5rem;"><span class="sr-only">Loading...</span></div>',
      )
      const end = () => {
        btn.prop("disabled", false)
        btn.html(btn.data("text"))
      }
      callback({ firstName, lastName, dialog, end })
    }
  })
  dialog.modal({
    keyboard: false,
    backdrop: "static",
  })
}

function toastAlert(success, icon, message) {
  const template = `
        <div class="toast toast-subscriber toast-${
          success ? "success" : "error"
        } position-fixed" role="alert" aria-live="assertive" aria-atomic="true" data-autohide="true" data-delay="3000" style="z-index: 99999;${
    algoras.isRtl ? "left" : "right"
  }: 15px;${algoras.isRtl ? "right" : "left"}: auto; top: 15px;">
            <div class="toast-header">
                <span class="m${
                  algoras.isRtl ? "l" : "r"
                }-auto"><span class="fas fa-${icon}"></span>&nbsp;<strong>${translate(
    success ? "Success" : "Error",
  )}</strong></span>
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body">
               ${message}
            </div>
        </div>
    `
  toastDialog = $(template)
  if ($(".toast-subscriber").length === 0) {
    $("body").append(toastDialog)
  }
  $(toastDialog).toast("show")
}

function removeToast() {
  if (toastDialog) {
    $(toastDialog).toast("dispose")
    toastDialog = null
    $(".toast-subscriber").remove()
  }
}

function validateEmail(mail) {
  if (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      mail,
    )
  ) {
    return true
  }
  return false
}
